import { useParams, Link } from "react-router-dom";

export default function ToolPlaceholder() {
  const { slug } = useParams();
  const title = slug ? slug.replace(/[-_]/g, " ") : "Tool";
  return (
    <main style={{ padding: "120px 0 80px" }}>
      <div className="container">
        <div className="card-base" style={{ padding: 40, textAlign: "center" }}>
          <h1 style={{ fontFamily: "Fraunces, serif", fontSize: 32, marginBottom: 12 }}>Coming soon</h1>
          <p style={{ color: "var(--t2)", marginBottom: 24 }}>The <strong>{title}</strong> tool is in progress. We'll have it live shortly.</p>
          <Link to="/other-tools" className="btn btn--primary">Back to tools</Link>
        </div>
      </div>
    </main>
  );
}
